import {RecipientForm} from '@/scripts/optional/recipient-form';
import {safeDefineElement} from '@/scripts/core/global';
safeDefineElement(RecipientForm);
